<template>
  <div class="expenses">
    <div class="expenses-upload">
      <el-select class="white" v-model="warehouseId" placeholder="请选择仓库">
        <el-option
          v-for="item in warehouse"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-upload
        :disabled="warehouseId && date ? false : true"
        v-loading.fullscreen.lock="loading"
        element-loading-text="文件上传中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="upload"
        ref="upload"
        action="#"
        :show-file-list="false"
        :auto-upload="true"
        :before-upload="uploadExcel"
      >
        <el-button slot="trigger" class="btn-blue" @click="watch"
          >费用导入</el-button
        >
      </el-upload>
      <el-button class="btn-blue" @click="feeCalculate">费用预估</el-button>
    </div>
    <div class="table-container">
      <div class="btn-list">
        <div class="btn-left">
          <el-button
            :class="type === 1 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(1)"
            >成本</el-button
          >
          <el-button
            :class="type === 2 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(2)"
            >管理</el-button
          >
          <el-button
            :class="type === 3 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(3)"
            >销售</el-button
          >
          <el-button
            :class="type === 4 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(4)"
            >财务</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" style="width: 80%">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.state===1" class="already">已纳入</span>
              <span v-else class="no-already">未纳入</span>-->
              <el-switch
                @change="updateState(scope.row.id, scope.row.stateBoolean)"
                v-model="scope.row.stateBoolean"
                active-color="#2E68EA"
                inactive-color="#D5D5D6"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  data() {
    return {
      warehouseId: "",
      date: "",
      loading: false,
      warehouse: [],
      type: 1,
      tableData: [],
      selectData: []
    };
  },
  created() {
    this.getWarehouse();
    this.getFeeTableData();
  },
  methods: {
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    watch() {
      if (!this.warehouseId || !this.date) {
        this.$message.error("请选择仓库或时间");
      }
    },
    //上传文件
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("warehouseId", this.warehouseId);
      formData.append("reportDate", this.date);
      this.loading = true;
      expenses
        .postImportExpenses(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loading = false;
          } else {
            this.loading = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          console.log(res);
          this.$message.error("导入失败");
          this.loading = false;
        });
      return false;
    },
    feeCalculate() {
      if (!this.warehouseId || !this.date) {
        this.$message.error("请选择仓库或时间");
        return false;
      }
      let warehouseId = this.warehouseId;
      let reportDate = this.date;
      expenses.getFeeCalculate(warehouseId, reportDate).then(res => {
        if (res.success) {
          this.$message.success("预估成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //费用列表
    getFeeTableData() {
      let type = this.type;
      expenses.getFeeList(type).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.state = value.statisticsStatus;
            obj.stateBoolean = value.statisticsStatus === 1;
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //切换类型
    selectType(type) {
      this.type = type;
      this.getFeeTableData();
    },
    saveSelect() {
      this.$confirm("您选择了一些费用，请确认是否保存?", "保存", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "保存成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    updateState(id, value) {
      let status;
      if (value) {
        status = 1;
      } else {
        status = 0;
      }
      expenses.getUpdateType(id, status).then(res => {
        if (res.success) {
          console.log("成功");
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.expenses {
  flex: 1;
  .expenses-upload {
    display: flex;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    .el-select {
      margin-right: 16px;
    }
    .upload {
      margin-left: 16px;
      margin-right: 16px;
    }
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .btn-list {
      display: flex;
      width: 80%;
      justify-content: space-between;
      margin-bottom: 16px;
      .btn-left {
        display: flex;
        .btn-select {
          background: rgba(46, 104, 234, 1);
          border-radius: 16px;
          color: #fff;
          border: 1px solid #2e68ea;
          margin-right: 16px;
        }
        .btn-no-select {
          background: #fff;
          border-radius: 16px;
          color: rgba(46, 104, 234, 1);
          border: 1px solid #2e68ea;
          margin-right: 16px;
        }
        .btn-no-select:hover {
          background: rgba(46, 104, 234, 1);
          border-radius: 16px;
          color: #fff;
          border: 1px solid #2e68ea;
          margin-right: 16px;
        }
      }
      .btn-right {
        .btn-save {
          background: rgba(248, 118, 121, 1);
          border-radius: 16px;
          color: #fff;
          border: 1px solid #f87679;
        }
      }
    }
    .table {
      .el-table {
        .already {
          color: #333333;
        }
        .no-already {
          color: #b5b5b5;
        }
      }
    }
  }
}
</style>
